'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

export type WysiwygEditorProps = {
  value?: string;
  onChange?: (value: string) => void;
  defaultValue?: string;
  placeholder?: string;
  className?: string;
  minHeight?: number;
  readOnly?: boolean;
  modules?: Record<string, unknown>;
  formats?: string[];
};

const defaultModules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ header: [1, 2, 3, false] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

const defaultFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'list',
  'bullet',
  'link',
];

export const WysiwygEditor = ({
  value,
  onChange,
  defaultValue = '',
  placeholder = 'Write something...',
  className,
  readOnly = false,
  modules = defaultModules,
  formats = defaultFormats,
}: WysiwygEditorProps) => {
  const [internalValue, setInternalValue] = React.useState(defaultValue);

  const isControlled = value !== undefined;
  const editorValue = isControlled ? value : internalValue;

  const handleChange = (content: string) => {
    if (!isControlled) {
      setInternalValue(content);
    }
    onChange?.(content);
  };

  return (
    <div
      className={cn('bg-white border rounded-md overflow-hidden', className)}
    >
      <ReactQuill
        theme="snow"
        value={editorValue}
        onChange={handleChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
        readOnly={readOnly}
        className="min-h-[160px]"
      />
    </div>
  );
};
